// extracted by mini-css-extract-plugin
export default {"root":"tkABD2VRguBn1DnkJQFY","info":"p3ccOlD5PS_a6wWhVD_L","name":"gMmdiLQbveJtoMmJwo_W","career":"G0Uz4Nr5tOf4R4fTd_oj","skeleton":"utD3o88drZCe4anzPSy8"};